export const InputVariantStandard = "standard";
export const InputVariantOutlined = "outlined";
export const InputVariantFilled   = "filled";

export const InputLabelDisplayModeInside = "inside";
export const InputLabelDisplayModeAbove  = "above";

export const TextFieldTypeText   = "text";
export const TextFieldTypeEmail  = "email";
export const TextFieldTypeNumber = "number";
export const TextFieldTypePhone  = "tel";

export const CheckboxLabelPlacementStart = "start";
export const CheckboxLabelPlacementEnd   = "end";

export const ClearItemValue = "_all";

export const TextFieldCapitalizationNone = "none";
export const TextFieldCapitalizationCapitalize = "capitalize";
export const TextFieldCapitalizationUppercase = "uppercase";
export const TextFieldCapitalizationLowercase = "lowercase";
